var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"listagem"},_vm._l((_vm.contents.content),function(item){return _c('li',{domProps:{"innerHTML":_vm._s(item.content)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }